<style>
  form {
    color: black;
    background-color: rgba(255, 255, 255, 0.192);
    width: auto;
    max-width: 500px;
    padding: 1rem;
  }
  form * {
    text-align: left;
  }
  :global(.lump-dashed--form, .lump-solid--form) {
    border-left-color: black!important;
  }
  button.main {
    font-size: 14px;
  }
 
.explainer
{
 font-family: Montserrat;
 font-size: 13px;
} 
</style>
<!-- /**
 * @param {
 *  campaignLengthDays: Number,
 *  filename: String,
 *  contentType
 *  file
 * }
 * @returns 201 if succesfull
 * {
 *  adIds: [String]
 * }
 */
router.post("/announcement", -->
<script>
  import {BSPost} from '../js-core/conn/reqs'
  import {getToken} from '../js-core/conn/auth/auth-main'
  import UploadFile from '../components/shared/forms/UploadFile.svelte'
  export let params
  let title = null, fileUploadLabel = null, errOccured = false, success = false, uploadLoading = false, campaignLengthDays, errMsg
  let bucketId
  async function uploadAnnouncement(e) {
    e.preventDefault();
    uploadLoading = true
    success = false
    errOccured = false
    const contentType = "image/png";
    const res = await BSPost("tv-owner/announcement", JSON.stringify({
      bucketId,
      campaignLengthDays,
      contentType,
      filename: title
    }))
    const resBody = await res.json();
    if (res.status === 201) {
      errOccured = false
      uploadLoading = false
      success = true
      alert('Your announcement has been uploaded successfully. You should see the announcement appear on your screens shortly')
      window.location.hash = `#/brite-host/${params.group}/manage-spots`
    } else {
      if (res.status === 400)
        errMsg = resBody.response.status
      console.log(errMsg)
      errOccured = true
      uploadLoading = false
    }
  }
</script>
<div class="row justify-content-center" style="width: 100%;">
  <!-- <Info infoTitle="what's required from you?" info="
  <p>High Quality ads---both in terms of resolution and content</p>
  <p>A 16 x 9 aspect ratio</p>
  <p>All Content must adhere to our ad guidlines</p>    
  ">
  </Info> -->
</div>
<div class="container center-content">
  <form on:submit="{ (e) => { uploadAnnouncement(e) } }">
    <div class="form-group">
      <input class="" id="ad-title-input" placeholder="Announcement Title" bind:value={title} required/>
    </div>
    <div class="form-group">
      <div class="custom-file">
        <UploadFile accept="image/png,image/jpg" required="true" bind:bucketId={bucketId} />
      </div>
      <div class="explainer">
        <p>File Requirements:</p>
        <p>Must be in 16:9 aspect ratio.</p>
        <p>Must be a PNG or JPG file.</p>
        Must adhere to our 
        <div class="Tooltip">Brite Host Guidelines
            <span class="Tooltiptext">Images must not depict any obscene images, any aggressive advertising tactics, no images or text depicting scams. Just be nice. Brite Signal reserves the right to take down any image deemed in breach of guidelines</span>
        </div>
      </div>
      <div class="Tooltip">Number of Days in announcement <span class="required--input">(*)</span>
        <span class="Tooltiptext">This is how long you want your campaign to stay up.</span>
      </div>
      <div class="lump-dashed--form">
        <div class="">
          <input
            class="form-control"
            type="number"
            id="lower-bound-socioeconomic-input"
            placeholder="Number of Days"
            bind:value={campaignLengthDays}
            required
          />
        </div>
      </div>
      {#if errOccured}
        <br>
        {#if errMsg}
          {errMsg}
        {:else}
          An error occured in uploading an announcement, please try again later
        {/if}
      {:else if success}
        <br>
          Your announcement has been uploaded successfully. You should see the announcement appear on your screens shortly
      {/if}
      <div class="form-group">
        <button type="submit" class="main btn btn-primary {uploadLoading ? 'loading' : ''}">
          Upload Announcement
        </button>
      </div>
    </div>
  </form>
</div>
